module.exports = __webpack_public_path__ + "img/trash.fc8a62e2.png";